import React from "react";
import LegalPageRenderer from "../components/LegalPageRenderer";

const TermsOfService = () => (
  <LegalPageRenderer slug="terms-of-service" testId="terms-of-service-page" />
);

export default TermsOfService;
